export const sectionTips =
{
    "Главная": "0",
    "КонкурсыБаннер": '7',
    "Конкурсы": '71',
    "ЕстьИдея": "8",
    "НашиЛюди": "13",
    "ДоскаПочета": "14",
    "Блоги": "15",
    "Видеоинтервью": "16",
    "НовомуСотруднику": "18",
    "ДниРождения": "19",
    "ОткрытыеВакансии": "111",
    "НовыеСотрудники": "112",
    "ВидеоинтервьюРуководство": "161",
    "проведенныеТренинги": "172",
    "УчЛитература": "175",
    "открытки": "22",
    "референсы": "25",
    "АктуальныеНовости": "31",
    "НовостиОргРазвития": "32",
    "Видеорепортажи": "33",
    "газетта": "34",
    "синертим":"35",
    "гидПредприятиям": "41",
    "офСобытия": "42",
    "фильмыЕмк": "43",
    "КорпоративныеСобытия": "51",
    "КорпоративнаяЖизнь": "52",
    "Афиша": "53",
    "БонусыПартнеров": "54",
    "Благотворительность": "55",
    "МагазинМерча": "56",
    "КонтентБлогов": "77",
}
